import Api from '../api';

const ADMIN_ENDPOINT = 'admin/formats';
const ENTITY_ENDPOINT = 'entity/formats';

export default {
    state: {
        formats: [],
    },

    getters: {
        getFormats: state => state.formats
    },

    mutations: {
        setFormats: (state, formats) => state.formats = formats,
        setFormat: (state, format) => state.formats.unshift(format),
        updateFormat: (state, format) => {
            const element = state.formats.find(form => form.id == format.id);
            const index = state.formats.indexOf(element);
            state.formats.splice(index, 1, format);
        }
    },

    actions: {
        async fetchFormats({commit}){
            const response = await Api.get(ADMIN_ENDPOINT);
            commit('setFormats', response.body.data);
        },
        async storeFormat({commit}, data){
            const response = await Api.post(ADMIN_ENDPOINT, data);
            commit('setFormat', response.body.data)
        },
        async updateFormat({commit}, format){
            const response = await Api.put(`${ADMIN_ENDPOINT}/${format.id}`, format);
            commit('updateFormat', response.body.data);
        },
        async fetchEntityFormats({commit}){
            const response = await Api.get(ENTITY_ENDPOINT);
            commit('setFormats', response.body.data)
        }
    }
}